import { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";

const STORAGE_KEY = "otelpro_kvkk_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Slight delay so it doesn't pop before hero renders
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const consent = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value, at: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-[420px] z-[90] bg-navy text-white rounded-xl shadow-2xl border border-white/10 p-4 md:p-5 animate-[slideUp_.4s_ease]"
      role="dialog"
      aria-live="polite"
    >
      <button
        onClick={() => consent("dismiss")}
        className="absolute top-2 right-2 text-white/50 hover:text-white p-1"
        aria-label="Kapat"
        data-testid="cookie-dismiss"
      >
        <X size={16} />
      </button>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5 text-gold">
          <Cookie size={22} />
        </div>
        <div className="flex-1">
          <h3 className="heading-serif text-base md:text-lg font-semibold text-gold mb-1">
            Çerezler & KVKK Aydınlatma
          </h3>
          <p className="text-xs md:text-[13px] leading-relaxed text-white/80 mb-3">
            Deneyiminizi kişiselleştirmek ve sitemizi geliştirmek için çerezleri kullanıyoruz.
            Kişisel verilerinizin 6698 sayılı KVKK kapsamında işlenmesine dair aydınlatma metnimize
            göz atın. Devam ederek çerez kullanımını kabul etmiş sayılırsınız.
          </p>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => consent("accepted")}
              className="bg-gold hover:bg-[#c49d58] text-navy text-xs font-semibold px-4 py-2 rounded-md transition"
              data-testid="cookie-accept"
            >
              Kabul Ediyorum
            </button>
            <button
              onClick={() => consent("essential-only")}
              className="border border-white/30 hover:border-white/60 text-white text-xs px-4 py-2 rounded-md transition"
              data-testid="cookie-essential-only"
            >
              Yalnız Zorunlu
            </button>
            <a
              href="/kvkk"
              className="text-[11px] underline text-white/60 hover:text-gold self-center"
              data-testid="cookie-learn-more"
            >
              Ayrıntılar
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
